// @ts-nocheck
import React, { useContext, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { FaLocationDot, FaPlus } from "react-icons/fa6";
import { GoArrowRight } from "react-icons/go";
import bagSolid from "../../../../assets/bag-solid.png";
import cashMultiple from "../../../../assets/cash-multiple.png";
import dummyComapyLogo from "../../../../assets/dummyComapyLogo.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { COMPANY_URLS } from "../../../../Utils/Company_App_Urls";
import { warningPopup } from "../../../../Utils/ToasterMessage";
import CompanyContext from "../../../Component/ContextAPI/CompanyContext";
import "./JobPostCards.css";
import { EventButton } from "../../../../User/component/ReUseComps/Button";
import { IoSearch } from "react-icons/io5";
import { getJobPostedDate } from "../../../Component/CustomHook/jobPostedDate";
import Pagination from "../../../../User/component/Pagination";
export default function JobPostCards() {
  const navigate = useNavigate();
  const { setIsJobCreated, needTorender, setCloseJobModalOpen } =
    useContext(CompanyContext);
  const [allJobs, setAllJobs] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [filterInputFiled, setFilterInputFiled] = useState("");
  const [filterUsingInputField, setFilterUsingInputField] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [activeFilterBtn, setActiveFilterBtn] = useState({
    all: true,
    open: false,
    close: false,
  });

  const reDirectToDetailsPage = (id) => {
    navigate(`/company/job-post/job-details/${id}`, {
      state: { jobId: id },
    });
  };

  const closeJobOpening = (status, id) => {
    if (status === "Open") {
      setCloseJobModalOpen({ status: true, data: { id: id } });
    } else {
      warningPopup("This job has been already closed.");
    }
  };

  const getAllJobPost = (pageNo = 1) => {
    axios
      .get(`${COMPANY_URLS.getAllJobs}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          page: pageNo,
          limit: 10,
        },
      })
      .then((res) => {
        const jobs = res?.data?.data?.jobs || [];
        setAllJobs(jobs);
        setFilteredJobs(jobs);
        setFilterUsingInputField(jobs);
        setIsJobCreated(true);
        setTotalPages(res?.data?.data?.totalPages || 1);
        setCurrentPage(res?.data?.data?.currentPage || 1);
      })
      .catch((err) => {
        console.error("Error fetching jobs:", err);
      });
  };

  const filterOptionChange = (type) => {
    setActiveFilterBtn({
      all: type === "all",
      open: type === "open",
      close: type === "close",
    });

    let filtered = [];
    if (type === "all") {
      filtered = allJobs;
    } else if (type === "open") {
      filtered = allJobs.filter((job) => job.status === "Open");
    } else if (type === "close") {
      filtered = allJobs.filter((job) => job.status === "Close");
    }

    setFilteredJobs(filtered);
    setFilterUsingInputField(filtered);
    setFilterInputFiled("");
  };

  const handleFilterInputSearch = (e) => {
    let keyWord = e.target.value;
    setFilterInputFiled(e.target.value);

    const filteredJob = filteredJobs?.filter((data) => {
      const title = data?.title?.toLowerCase();
      return title?.includes(keyWord.toLowerCase());
    });
    setFilterUsingInputField(filteredJob);
  };

  useEffect(() => {
    getAllJobPost(currentPage);
  }, [needTorender, currentPage]);

  return (
    <div className="job-post-card-container">
      <div className="w-100 d-flex align-items-center flex-row justify-content-between mb-1 mt-5">
        <p className="job-post-vailable-para mb-3">
          Total <span>{allJobs?.length}</span> Jobs posted
        </p>
        <EventButton
          id="jopPostBtn"
          className="d-flex align-items-center justify-content-center gap-2"
          onClick={() => navigate("/company/create-job")}
        >
          <FaPlus fontSize={16} />
          Create Job
        </EventButton>
      </div>

      <div className="filterOption_postedJob mb-1 d-flex align-items-center gap-2 justify-content-between flex-wrap">
        <div className="jobFilterBtnGrp d-flex align-items-center gap-1">
          <button
            onClick={() => filterOptionChange("all")}
            className={`${activeFilterBtn.all && "jobPostFilterButton"}`}
          >
            All
          </button>
          <button
            onClick={() => filterOptionChange("open")}
            className={`${activeFilterBtn.open && "jobPostFilterButton"}`}
          >
            Open
          </button>
          <button
            onClick={() => filterOptionChange("close")}
            className={`${activeFilterBtn.close && "jobPostFilterButton"}`}
          >
            Close
          </button>
        </div>
        <div className="filterInputGrp d-flex align-items-center justify-content-between gap-2">
          <IoSearch fontSize={20} />
          <Form.Control
            className="border-0 shadow-none"
            placeholder="Job Title"
            aria-label="Job Title"
            aria-describedby="basic-addon1"
            value={filterInputFiled}
            onChange={handleFilterInputSearch}
          />
        </div>
      </div>

      <div>
        {filterUsingInputField?.length > 0 ? (
          filterUsingInputField?.map((job, index) => {
            console.log(job);

            return (
              <div className="job-post-search-body mb-3" key={index}>
                <div className="job-post-cards d-flex flex-wrap">
                  <div className="job-post-right-container d-flex flex-column gap-1 flex-grow-1">
                    <div className="job-post-card-header d-flex align-items-start justify-content-start flex-wrap gap-2">
                      <div className="job-post-company-title d-flex align-items-start gap-3">
                        <div>
                          <img
                            src={
                              job?.companyProfileDetail?.[0]?.companylogo ||
                              dummyComapyLogo
                            }
                            alt={job?.company}
                          />
                        </div>
                        <div className="job-post-compay-name mb-2">
                          <h1 className="m-0">{job?.title}</h1>
                          <p className="m-0">
                            {job?.companyProfileDetail?.[0]?.companyName}
                          </p>
                        </div>
                        {job?.status === "Open" ? (
                          <span className="active-status closed-status ms-2">
                            <div className="green_dot" /> <span>Open</span>
                          </span>
                        ) : (
                          <span className="closed-status ms-2">
                            <div className="red_dot" /> <span>Closed</span>
                          </span>
                        )}
                      </div>
                      <p className="m-0 d-flex flex-column posted_date">
                        <span>
                          {getJobPostedDate(job?.createdAt?.split("T"))}
                        </span>
                      </p>
                    </div>

                    <div className="job-post-conadtion-box">
                      <div>
                        <img src={bagSolid} alt="bag solid" />{" "}
                        <span>{job?.experience}</span>
                      </div>
                      {job?.salaryType === "Fixed Salary" && (
                        <div>
                          <img src={cashMultiple} alt="cash multiple" />{" "}
                          <span>
                            {job?.FixedSalary
                              ? `${job?.FixedSalary} LPA`
                              : "N/A"}
                          </span>
                        </div>
                      )}
                      {job?.salaryType === "Salary Range" && (
                        <div>
                          <img src={cashMultiple} alt="cash multiple" />{" "}
                          <span>
                            {job?.minSalary
                              ? `${job?.minSalary} - ${job?.maxSalary} LPA`
                              : "N/A"}
                          </span>
                        </div>
                      )}
                      {job?.salaryType === "Not Disclose" && (
                        <div>
                          <img src={cashMultiple} alt="cash multiple" />{" "}
                          <span>{job?.salaryType}</span>
                        </div>
                      )}
                      <div>
                        <FaLocationDot />{" "}
                        <span className="text-capitalize">
                          {job?.jobLocations || "N/A"}
                        </span>
                      </div>
                    </div>

                    <div className="job-post-preferences d-flex gap-1 gap-sm-2 flex-wrap">
                      <span>{job?.deparmentType}</span>
                      <span>{job?.educationRequiement}</span>
                      <span>
                        {job?.noOfOpening
                          ? `${job?.noOfOpening} Openings`
                          : "N/A"}
                      </span>
                    </div>

                    <div className="job-post-desp-inCard">
                      <div>{job?.jobSummary}</div>
                    </div>

                    <div className="job-post-company-req-skills d-flex flex-wrap gap-2 gap-sm-2">
                      {job?.skills?.slice(0, 5).map((skill, index) => (
                        <span key={index}>{skill}</span>
                      ))}
                      {job?.skills?.length > 5 && (
                        <span>+{job?.skills?.length - 5} more</span>
                      )}
                    </div>
                  </div>

                  <div className="job-post-cards-btn-box flex-row flex-sm-column flex-wrap">
                    <button
                      className="job-post-search-btn"
                      onClick={() => reDirectToDetailsPage(job?._id)}
                    >
                      View <GoArrowRight fontSize={20} />
                    </button>
                    <button
                      disabled={job?.status === "Close"}
                      className={`job-post-outline-btn ${job?.status === "Close" && "closed_hiring"
                        }`}
                      onClick={() => closeJobOpening(job?.status, job?._id)}
                    >
                      Close Hiring
                    </button>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="filterOption_postedJob">
            <p className="text-center align-item-center">No Job Found</p>
          </div>
        )}

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      </div>
    </div>
  );
}
